<page-context [page]="this">
  <div class="newsletter-container">
    <div>
		  <div class="image-container">
			  <div (click)="!submitted && selectNewsletter('newsletter')" class="image-item" [ngClass]="newsletterTypes['newsletter'] ? 'selected' : 'image'">
				  <div class="image progress_report"></div>

				  <div class="text-container">
					  <h4 class="title">Progress Report</h4>
					  <p class="description">
						  Get your daily dose of TYT with up-to-the-minute exclusive articles, post show analysis and happenings on the network!
					  </p>
				  </div>

				  <div class="checkbox-container">
					  <div class="checkbox"></div>
				  </div>
			  </div>
		  </div>

      <div class="image-container">
        <div (click)="!submitted && selectNewsletter('shop')" class="image-item" [ngClass]="newsletterTypes['shop'] ? 'selected' : 'image'">
          <div class="image shop"></div>

          <div class="text-container">
            <h4 class="title">Shop Newsletter</h4>
            <p class="description">
              Check out the latest merchandise and special limited time offers in Shop TYT so you may proudly wear your support!
            </p>
          </div>

          <div class="checkbox-container">
            <div class="checkbox"></div>
          </div>
        </div>
      </div>

      <form (submit)="signUp()">
        <ng-container *ngIf="!submitted">
          <p class="call-to-action">Select a newsletter & enter your email</p>
          <p *ngIf="errorText" class="error">{{ errorText }}</p>
          <div class="form-group">
            <input errorHighlight type="text" name="email" class="form-control" placeholder="Your email" [(ngModel)]="email">
          </div>
          <button type="submit" class="sign-up-btn">
            Sign Me Up!
            <img src="/assets/yellow-arrow-right.svg" alt="">
          </button>
        </ng-container>
        <ng-container *ngIf="submitted">
          <h1>THANK YOU!</h1>
          <p>Now just make sure our email addresses are in your safe senders list so your newsletters don't get sent to spam or promotions, and we'll see you in the next edition!</p>
          <ul>
            <li *ngFor="let type of selectedNewsletter">
              {{newsletterEmails[type]}}
            </li>
          </ul>
        </ng-container>
      </form>
    </div>
  </div>
</page-context>
